import {
  GET_USERDETAILS,
  SET_USERDETAILS,
} from "../constants/user-details-constants";

const initialState = {
  data: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USERDETAILS:
      const { data } = action;
      return { ...state, data };
    default:
      return state;
  }
};
